module.exports = __webpack_public_path__ + "static/epitome-keqing-banner-26b265e233563586299c4d84dc54b293.png";